var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1028,
    height: 1053,
    viewBox: "0 0 1028 1053",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.92 966.4C238.94 961.73 299.14 947.43 285.77 906.685C271.13 862.025 218.13 863.295 191.89 870.355C165.65 877.425 119.67 909.255 133.68 944.71C148.83 983 196.02 970.82 216.92 966.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.571 961.11C273.438 961.11 287.111 947.44 287.111 930.57C287.111 913.708 273.438 900.035 256.571 900.035C239.704 900.035 226.031 913.708 226.031 930.57C226.031 947.44 239.704 961.11 256.571 961.11Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.281 915.025C230.281 915.025 226.191 892.895 230.281 891.375C234.371 889.865 245.701 902.025 245.701 902.025C245.701 902.025 240.361 903.895 237.081 907.055C233.801 910.215 230.281 915.025 230.281 915.025Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.211 909.025C278.211 909.025 302.921 905.515 303.591 911.235C304.261 916.955 286.761 925.965 286.761 925.965C286.761 925.965 285.361 918.635 282.861 915.025C280.361 911.415 278.211 909.025 278.211 909.025Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.271 897.655C147.271 897.655 119.331 923.685 126.481 954.81C134.111 988.01 195.711 1010.2 222.171 977.02C243.371 950.44 207.701 935.64 196.941 952.46C181.841 976.05 116.991 977.85 147.271 897.655Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.081 931.25C237.081 931.25 218.311 928.22 206.871 932.43",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.49 942.53C274.49 942.53 290.46 951.33 293.33 954.81",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.08 936.64C237.08 936.64 220.51 936.3 209.23 941.69",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.211 948.67C271.211 948.67 286.601 961.02 289.381 970.36",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.49 614.305L787.76 609.265",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M638.371 891.245L755.05 889.855L745.61 925.045L638.371 925.305V891.245Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.179 459.365C361.179 459.365 325.469 509.335 333.549 549.715C341.619 590.085 388.02 616.845 459.72 614.315C453.66 674.875 464.61 892.925 464.61 892.925L638.369 891.245L739.311 889.845V596.635L598.549 488.025C598.539 488.035 531.419 461.095 361.179 459.365Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M541.471 512.365L631.301 594.125L638.371 891.245",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M450.631 893.045L661.921 891.245L653.851 925.245L461.411 925.965L450.631 893.045Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M729.21 925.305V948.67L790.67 992.22L638.371 993.55V925.305H729.21Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M465.77 925.965L638.37 925.305V950.94L699.45 992.81L467.32 995.58L465.77 925.965Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M497.17 424.105L501.6 374.085L539.961 345.345C539.961 345.345 490 275.675 467.79 272.145C455.17 281.225 445.081 266.595 445.081 266.595C445.081 266.595 377.14 268.755 358.98 333.355C398.35 345.975 426.92 353.645 426.92 353.645L434.99 322.615L417.331 407.905L497.17 424.105Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.6 374.085L497.17 424.105L417.331 407.905L434.99 322.615L426.92 353.645C426.92 353.645 398.35 345.975 358.98 333.355C377.14 268.755 445.081 266.595 445.081 266.595C445.081 266.595 455.17 281.225 467.79 272.145C490 275.675 539.961 345.345 539.961 345.345L501.6 374.085ZM501.6 374.085L498.07 321.595",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358.971 333.345C358.971 333.345 334.881 442.715 339.601 450.795C344.311 458.865 475.571 485.455 509.891 486.685C544.211 487.915 534.041 436.985 523.631 431.105C513.211 425.225 417.331 407.895 417.331 407.895L426.921 353.635L358.971 333.345Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M503.121 373.325L533.541 350.215L557.121 390.235L533.541 431.615L497.211 423.755L503.121 373.325Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M504.38 272.385C526.45 264.935 517.71 223.075 505.89 206.275C484.95 176.495 433.47 181.545 420.09 221.925C417.17 230.725 399.23 234.585 406.21 248.675C411.09 258.515 430.69 253.395 430.69 253.395C430.69 253.395 491.17 276.845 504.38 272.385Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M445.081 266.585L450.381 251.445C450.381 251.445 444.831 243.875 445.081 239.585C445.331 235.295 436.751 238.325 439.021 229.495C441.291 220.665 452.391 230.505 457.951 232.775C463.511 235.045 473.791 229.635 479.151 229.245C482.801 228.975 486.501 232.505 487.551 234.845C489.671 239.595 486.721 246.405 481.171 249.685C475.621 252.965 467.291 253.475 467.291 253.475L466.461 273.025C466.461 273.025 465.291 277.145 454.431 274.145C443.561 271.125 445.081 266.585 445.081 266.585Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 488.985H1026.22",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.691 1029.67L274.491 488.985",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.83 488.985L333.54 1052.38",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M777.16 488.985L964.9 1052.38",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M765.051 1022.09L905.851 488.985",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5001 422.025C77.5001 422.025 58.6601 374.755 32.0801 362.645",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0804 362.645C32.0804 362.645 11.8105 330.425 3.73045 339.765C-7.29955 352.525 32.0804 362.645 32.0804 362.645Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3116 387.005C51.0916 371.385 30.1016 401.085 30.1016 401.085C30.1016 401.085 62.2416 395.505 58.3116 387.005Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0508 303.675C95.8408 351.365 106.431 422.915 106.431 422.915L92.0508 303.675Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0508 303.675C95.8408 351.365 106.431 422.915 106.431 422.915",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7195 258.415C95.7595 257.815 113.629 311.035 91.4895 308.475C71.8595 306.205 89.7195 258.415 89.7195 258.415Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6407 331.055C94.6407 331.055 84.2307 313.525 67.0707 312.175C49.9107 310.825 47.2207 312.175 47.2207 312.175",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5501 310.325C43.4701 290.155 13.4102 314.365 13.4102 314.365C13.4102 314.365 48.6501 324.115 46.5501 310.325Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2812 354.235C97.2812 354.235 105.581 337.515 126.461 325.965C142.271 317.215 151.191 314.625 151.191 314.625",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.201 314.625C145.631 290.485 201.321 305.575 201.321 305.575C201.321 305.575 156.871 331.785 152.201 314.625Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.471 422.925C137.471 422.925 136.461 392.075 147.561 383.335",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M186.301 355.025C186.301 355.025 132.841 365.795 146.681 383.325C156.021 395.155 186.301 355.025 186.301 355.025Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M124.23 369.165C136.72 363.305 139.37 399.695 139.37 399.695C139.37 399.695 112 374.905 124.23 369.165Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.4 422.025H63.9004V488.975H154.4V422.025Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M497.211 489.045L589.921 301.045H839.57L757.49 489.045H497.211Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M691.36 385.995C691.36 385.995 681.77 383.385 674.96 388.185C672.01 390.265 662.7 397.525 667.57 403.575C672.44 409.635 681.52 404.335 685.06 399.035C688.59 393.735 691.36 385.995 691.36 385.995Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M951.949 469.975L984.919 215.275L835.449 133.855",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M835.449 133.855L763.189 164.465L836.88 210.225L835.449 133.855Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M799.071 209.385C809.631 209.385 818.181 200.829 818.181 190.275C818.181 179.721 809.631 171.165 799.071 171.165C788.521 171.165 779.961 179.721 779.961 190.275C779.961 200.829 788.521 209.385 799.071 209.385Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M999.829 467.355H902.779V487.985H999.829V467.355Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M677.71 173.425L667.32 166.355C667.32 166.355 641.96 196.385 649.78 202.565C658.34 209.335 677.71 173.425 677.71 173.425Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M685.26 173.585C698.25 173.585 708.78 163.055 708.78 150.065C708.78 137.075 698.25 126.545 685.26 126.545C672.271 126.545 661.74 137.075 661.74 150.065C661.74 163.055 672.271 173.585 685.26 173.585Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M685.26 165.145C692.959 165.145 699.2 158.904 699.2 151.205C699.2 143.506 692.959 137.265 685.26 137.265C677.561 137.265 671.32 143.506 671.32 151.205C671.32 158.904 677.561 165.145 685.26 165.145Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M652.881 186.315C652.881 186.315 652.691 190.625 655.911 194.035C657.741 195.975 661.501 197.025 661.501 197.025C661.501 197.025 654.271 206.525 649.731 202.365C645.181 198.195 652.881 186.315 652.881 186.315Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M444.911 86.915C461.728 86.915 475.361 73.282 475.361 56.465C475.361 39.648 461.728 26.0151 444.911 26.0151C428.094 26.0151 414.461 39.648 414.461 56.465C414.461 73.282 428.094 86.915 444.911 86.915Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M468.471 37.1851C480.861 39.0851 489.711 44.3951 491.051 51.9451C493.211 64.1151 474.801 75.3351 450.291 79.6851C425.781 84.0351 404.431 79.8551 402.271 67.6851C401.071 60.8951 406.181 53.7151 415.201 47.9551",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 14.4051C492.849 14.4051 495.71 11.5443 495.71 8.0152C495.71 4.4861 492.849 1.625 489.32 1.625C485.791 1.625 482.93 4.4861 482.93 8.0152C482.93 11.5443 485.791 14.4051 489.32 14.4051Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M389.82 97.435C393.349 97.435 396.21 94.574 396.21 91.045C396.21 87.516 393.349 84.655 389.82 84.655C386.291 84.655 383.43 87.516 383.43 91.045C383.43 94.574 386.291 97.435 389.82 97.435Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M208.71 197.775C222.827 197.775 234.27 186.331 234.27 172.215C234.27 158.099 222.827 146.655 208.71 146.655C194.594 146.655 183.15 158.099 183.15 172.215C183.15 186.331 194.594 197.775 208.71 197.775Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.78 181.125L201.99 177.925",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M222.18 173.895L213.93 164.135",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M196.771 173.895C196.771 173.895 194.251 169.855 195.931 167.335C197.611 164.815 201.991 167.335 201.991 167.335C201.991 167.335 201.991 160.605 204.351 158.755C206.221 157.285 210.741 160.265 210.741 160.265",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.132 175.905C235.132 175.905 241.022 177.925 240.682 181.125C240.342 184.325 226.212 201.145 223.022 201.485C219.822 201.825 217.102 196.375 217.102 196.375C217.102 196.375 225.862 192.905 228.902 187.905C231.932 182.895 235.132 175.905 235.132 175.905Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M239.76 184.895C239.76 184.895 245.23 185.165 244.72 188.365C244.21 191.565 232.57 205.045 228.9 203.255C226.15 201.905 225.9 199.795 227.49 198.215C230.1 195.625 239.76 184.895 239.76 184.895Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M244.12 191.105L252.37 198.545C252.37 198.545 246.46 206.705 244.75 206.535C243.03 206.365 235.25 200.995 235.25 200.995L244.12 191.105Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M272.221 146.655C272.221 146.655 296.441 114.925 339.851 88.1851L272.221 146.655Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M272.221 146.655C272.221 146.655 296.441 114.925 339.851 88.1851",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M288.461 149.165C288.461 149.165 304.111 125.615 331.021 106.095L288.461 149.165Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M288.461 149.165C288.461 149.165 304.111 125.615 331.021 106.095",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M545.17 63.865C545.17 63.865 588.57 67.225 631.98 107.605",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M561.91 82.625C561.91 82.625 592.7 89.695 623.48 115.175",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLight);
export default __webpack_public_path__ + "static/media/empty-light.702b938718f121ed0c6a1c8a06ce6255.svg";
export { ForwardRef as ReactComponent };